import { defineMessages, useIntl } from 'react-intl';

import { TwcSpotlightCard } from './TwcSpotlightCard';

import { buttonMessages } from './button-messages';

import { ROVO_SPOTLIGHT_NUMBER } from './constants';

import RovoChatIllustrationDark from '../assets/Rovo-Chat-Illustration-Dark.png';

import RovoChatIllustrationLight from '../assets/Rovo-Chat-Illustration-Light.png';

import { type JSX } from 'react/jsx-runtime';

type RovoChatSpotlightProps = {
	numTotalSpotlights: number;
	spotlightEnd: () => void;
	spotlightBack: () => void;
	openRovoPanel: () => void;
	isRovoChatOpen: boolean;
};

export const RovoChatSpotlight = (props: RovoChatSpotlightProps): JSX.Element => {
	const { spotlightEnd, spotlightBack, openRovoPanel, numTotalSpotlights, isRovoChatOpen } = props;
	const intl = useIntl();
	return (
		<TwcSpotlightCard
			testId="rovo-chat-spotlight"
			heading={intl.formatMessage(messages.heading)}
			body={intl.formatMessage(messages.body)}
			lightSrcImage={RovoChatIllustrationLight}
			darkSrcImage={RovoChatIllustrationDark}
			primaryActionFunction={isRovoChatOpen ? spotlightEnd : openRovoPanel}
			primaryActionText={
				isRovoChatOpen
					? intl.formatMessage(buttonMessages.spotlightOkButton)
					: intl.formatMessage(buttonMessages.spotlightTryNowButton)
			}
			secondaryActionFunction={spotlightBack}
			secondaryActionText={intl.formatMessage(buttonMessages.spotlightBackButton)}
			spotlightEnd={spotlightEnd}
			currentSpotlightNumber={ROVO_SPOTLIGHT_NUMBER}
			numTotalSpotlights={numTotalSpotlights}
			spotlightType="rovo"
		/>
	);
};

const messages = defineMessages({
	heading: {
		defaultMessage: 'Chat with AI',
		description:
			'Heading for team work collection onboarding tour spotlight for the rovo chat button',
		id: 'townsquare.twc-onboarding-spotlight.rovo-chat.heading',
	},
	body: {
		defaultMessage:
			'You could also use Rovo Chat to explore company knowledge, find helpful pages, and create new things.',
		description: 'Body for team work collection onboarding tour spotlight for the rovo chat button',
		id: 'townsquare.twc-onboarding-spotlight.rovo-chat.body',
	},
});
